// Choferes habituales de una zona o de una estantería: una lista de chips y
// un desplegable para agregar. Solo sirven para sugerir el chofer del reparto
// (Sistema → Zonas → Configuración → Chofer por zona); nunca asignan nada.

import React from "react";

export type DriverOption = { id: number; username: string; first_name: string | null; last_name: string | null };

export const driverLabel = (d: { first_name: string | null; last_name: string | null; username: string }) =>
  [d.first_name, d.last_name].filter(Boolean).join(" ").trim() || d.username;

const chipStyle: React.CSSProperties = {
  display: "inline-flex", alignItems: "center", gap: "6px", padding: "4px 6px 4px 10px", borderRadius: "999px",
  border: "1px solid var(--border)", background: "var(--surface-alt)", color: "var(--text-primary)", fontSize: "13px",
};
const selectStyle: React.CSSProperties = {
  padding: "8px 10px", borderRadius: "12px", border: "1px solid var(--border)", background: "var(--surface-alt)", color: "var(--text-primary)", fontSize: "14px",
};

export default function DriverMultiPicker({ drivers, value, onChange, disabled, id }: {
  drivers: DriverOption[];
  value: number[];
  onChange: (next: number[]) => void;
  disabled?: boolean;
  id?: string;
}) {
  const byId = new Map(drivers.map((d) => [d.id, d]));
  const free = drivers.filter((d) => !value.includes(d.id));
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", alignItems: "center" }}>
      {value.map((driverId) => {
        const d = byId.get(driverId);
        const label = d ? driverLabel(d) : `Chofer ${driverId}`;
        return (
          <span key={driverId} style={chipStyle}>
            {label}
            <button
              type="button" aria-label={`Sacar a ${label}`} disabled={disabled}
              onClick={() => onChange(value.filter((x) => x !== driverId))}
              style={{ border: 0, background: "transparent", color: "var(--text-secondary)", cursor: "pointer", fontSize: "15px", lineHeight: 1 }}
            >×</button>
          </span>
        );
      })}
      <select
        id={id} style={selectStyle} value="" disabled={disabled || !free.length}
        onChange={(e) => { const n = Number(e.target.value); if (n) onChange([...value, n]); }}
      >
        <option value="">{free.length ? "Agregar chofer…" : value.length ? "No quedan más choferes" : "No hay choferes activos"}</option>
        {free.map((d) => <option key={d.id} value={d.id}>{driverLabel(d)}</option>)}
      </select>
    </div>
  );
}
